import Vue from 'vue'
import axios from 'axios';
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'material-design-icons-iconfont/dist/material-design-icons.css' 

import Vue2Filters from 'vue2-filters'
import moment from 'moment'
Vue.prototype.moment = moment

// import Default from "./layouts/Default.vue";
// import NoSidebar from "./layouts/NoSidebar.vue";

// Vue.component("default-layout", Default);
// Vue.component("no-sidebar-layout", NoSidebar);
require('style-loader!../public/css/style.css')
require('style-loader!../public/css/colors/blue.css')
Vue.prototype.$http = axios;

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}
//https://api.innity.com.my/user?username=test.sales1&password=test.sales1&role_id=7%2C8%2C9%2C10
Vue.use(Vue2Filters)
Vue.filter('numofpercent', function (value) {
    return parseFloat(value).toFixed(2);
});
Vue.filter('format_date',function(value){
    return moment(value, 'YYYY-MM-DD').format('DD MMM, YYYY');
});
Vue.filter('format_number',function(value){
		if (value){
			 return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		}else
			return 0;
});
Vue.filter('format_numberS',function(value){
	 //Seperates the components of the number
	// console.log(value)
	if(value){
		var n= value.toString().split(".");
	    //Comma-fies the first part
	    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    //Combines the two sections
	    return n.join(".");
	}else{
		return 0;
	}
   

})
// Vue.filter('escapeHtml',function(value){
// 	var htmlEscapes = {
// 		  '&': '&amp;',
// 		  '<': '&lt;',
// 		  '>': '&gt;',
// 		  '"': '&quot;',
// 		  "'": '&#x27;',
// 		  '/': '&#x2F;'
// 		};
// 	var htmlEscaper = /[&<>"'\/]/g;
// 	_.escape = function(value) {
// 	  return ('' + string).replace(htmlEscaper, function(match) {
// 	  	  return htmlEscapes[match];
// 		  });
//  	 };	
// })

Vue.config.productionTip = false
// Vue.component('search-dialog', SearchDialog)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
